const modifiedFields = [
  'widgetName',
  'projectModel',
  'resourceTypeModel',
  'productModel',
  'selectedMetrics',
  'objectModel',
  'showThresholdValue',
  'targetsMethodModel',
  'thresholdValue',
  'comparisonOperator'
];
const modifiedFieldCustom = {};
const sortByFields = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
